import { defineMessages } from 'react-intl';

type MessageKeys = 'showLess' | 'viewAll';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description: string }
> = defineMessages({
	showLess: {
		id: 'studio-browse-kit.card-list.show-less.ai-non-final',
		defaultMessage: 'Show less',
		description: 'Button label that collapses a card list to show only its first row.',
	},
	viewAll: {
		id: 'studio-browse-kit.card-list.view-all.ai-non-final',
		defaultMessage: 'View all',
		description: 'Button label that expands a card list to show every card.',
	},
});
